import Rellax from 'rellax';

(() => {
	const selector = '.rellax';
	let container     = document.querySelector(selector);
	if (container) {
		new Rellax(selector);
	}
})();